import { Box, FormControl, MenuItem, Select, TextField } from "@mui/material";
import CustomInputCell from "./CustomInputCell";
import { fullHeadBorder, leftBorder, rightBorder } from "./colsBorders";
import { secondAxios } from "../../../../../../../../api/axios";
import { useState } from "react";

export const taggedMrqMaterialsColsEdit = (onChange = () => {}) => [
  {
    accessorKey: "UIDs",
    header: "UIDs",
    enableEditing: false,
    size: 150,
    Cell: ({ row }) => (
      <Box>
        {row.original.materials
          ?.map((m) => m.UID)
          .filter(Boolean)
          .join(", ")}
      </Box>
    ),
  },
  {
    accessorKey: "tagNumbers",
    header: "Part/Tag/Mark #",
    enableEditing: false,
    size: 150,
    Cell: ({ row }) => (
      <Box>
        {row.original.materials
          ?.map((m) => m.tagNumber)
          .filter(Boolean)
          .join(", ")}
      </Box>
    ),
  },
  {
    header: "Description",
    accessorKey: "description",
    enableEditing: false,
    size: 400,
  },
  {
    header: "Req. Quantity",
    accessorKey: "reqQty",
    enableEditing: false,
    size: 20,
    Cell: ({ row }) => {
      return <Box>{row.original.materials?.length}</Box>;
    },
  },
  {
    accessorKey: "procuredQty",
    header: "Procure Qty",
    enableEditing: false,
    grow: false,
    size: 10,
    Cell: ({ row }) => {
      return (
        <CustomInputCell
          name="procuredQty"
          row={row}
          onChange={onChange}
          placeholder="Add Quantity"
        />
      );
    },
  },
  {
    header: "Unit",
    accessorKey: "unit",
    enableEditing: false,
    size: 50,
    Cell: ({ row }) => {
      const isPlate = row.original?.description
        ?.toLowerCase()
        .includes("plate");
      const isPipe = row.original?.description?.toLowerCase().includes("pipe");
      const isHead = row.original?.costCode?.toLowerCase().includes("head");

      // console.log("poManager", row.original);
      if (row.original.unit) {
        return row.original.unit;
      } else if (isPipe && !isHead) {
        return "mm";
      } else {
        return "Nos";
      }
    },
  },
  {
    accessorKey: "remarks",
    header: "Remarks",
    enableEditing: false,
    grow: false,
    size: 200,
    ...rightBorder,
    Cell: ({ row }) => {
      return (
        <CustomInputCell
          name="remarks"
          row={row}
          onChange={onChange}
          type="string"
        />
      );
    },
  },
];

export const taggedMrqMaterialsCols = (isEditMode, onChange) => [
  {
    accessorKey: "uids",
    header: "UIDs",
    enableEditing: false,
    size: 100,
    Cell: ({ row }) => {
      // console.log("row", row.original);
      return (
        <Box>
          {row.original.materials?.map((m, i) => {
            return (
              // m.bulkMaterial?.item + ", "
              <p key={i}>- {m.UID || ""}</p>
            );
          })}
        </Box>
      );
    },
  },
  {
    accessorKey: "tagNumbers",
    header: "Part/Tag/Mark #",
    enableEditing: false,
    size: 100,
    Cell: ({ row }) => {
      // console.log("row", row.original);
      return (
        <Box>
          {row.original.materials?.map((m, i) => {
            return <p key={i}>- {m?.tagNumber || ""} </p>;
          })}
        </Box>
      );
    },
  },
  {
    accessorKey: "costCode",
    header: "Cost Code",
    enableEditing: false,
    grow: false,
    size: 60,
  },
  {
    header: "Description",
    accessorKey: "description",
    enableEditing: false,
    size: 250,
  },

  {
    header: "Dimension",
    accessorKey: "length",
    enableEditing: false,
    size: 250,
    Cell: ({ row }) => {
      return (
        row.original.materials?.[0]?.length ||
        row.original.materials?.[0]?.dimension ||
        ""
      );
    },
  },

  {
    header: "Procure Qty",
    accessorKey: "procuredQty",
    enableEditing: false,
    size: 20,
  },
  {
    header: "Unit",
    accessorKey: "procuredUnit",
    enableEditing: false,
    size: 50,
    Cell: ({ row }) => {
      const isPlate = row.original?.description
        ?.toLowerCase()
        .includes("plate");
      const isPipe = row.original?.description?.toLowerCase().includes("pipe");
      const isHead = row.original?.costCode?.toLowerCase().includes("head");

      if (isPlate) {
        return "Ft²";
      } else if (row.original.unit) {
        return row.original.unit;
        // } else if (isPipe && !isHead) {
        //   return "mm";
      } else {
        return "Nos";
      }
    },
  },
];

export const bulkMrqMaterialsCols = (isEditMode, onChange) => [
  {
    accessorKey: "bulkMaterial.item",
    header: "Items",
    enableEditing: false,
    grow: false,
    size: 50,
    Cell: ({ row }) => {
      console.log({ row: row.original });
      return (
        <Box>
          {row.original.materials
            ?.map((m) => m?.bulkMaterial?.item)
            .sort()
            .map((item, i) => {
              return <p key={i}>- {item}</p>;
            })}
        </Box>
      );
    },
  },
  {
    accessorKey: "quantity",
    header: "Quantity",
    enableEditing: false,
    grow: false,
    size: 50,
    Cell: ({ row }) => {
      const qty = row.original?.quantity;

      function formatNumber(num) {
        return Number.isInteger(num) ? num : num.toFixed(2);
      }

      return formatNumber(Number(qty));
    },
  },
  {
    accessorKey: "materialCode",
    header: "Material Code",
    enableEditing: false,

    size: 120,
  },
  {
    accessorKey: "description",
    header: "Description",
    enableEditing: false,

    size: 120,
  },
];

export const bulkDescriptionMrqMaterialsColsEdit = (onChange = () => {}) => [
  {
    accessorKey: "Consolidation Data",
    header: "Consolidation Data",
    ...fullHeadBorder,
    columns: [
      {
        accessorKey: "markNumber",
        header: "Mark #",
        enableEditing: false,
        grow: false,
        size: 150,
        ...leftBorder,
        Cell: ({ row }) => {
          console.log({ rowcccc: row.original });
          return (
            <Box>
              {row.original.materials
                ?.map(
                  (m) =>
                    m?.bulkMaterial?.markNumber ||
                    m?.bulkMaterial?.item ||
                    m?.markNumber,
                )
                .sort()
                .map((markNumber, i) => {
                  return <p key={i}>- {markNumber}</p>;
                })}
            </Box>
          );
        },
      },
      // {
      //   accessorKey: "costCode",
      //   header: "Cost Code",
      //   enableEditing: false,
      //   grow: false,
      //   size: 60,
      //   Cell: ({ row }) => {
      //     return <Box>{row.original.materials?.[0]?.costCode}</Box>;
      //   },
      // },
      {
        accessorKey: "description",
        header: "Description",
        enableEditing: false,

        size: 230,
      },

      {
        accessorKey: "length",
        header: "Dimension",
        enableEditing: false,
        grow: false,
        size: 10,
        ...leftBorder,
        Cell: ({ row }) => {
          // console.log("row", row.original);
          const isPipe = row.original?.description
            ?.toLowerCase()
            .includes("pipe");
          const isPlate = row.original?.description
            ?.toLowerCase()
            .includes("plate");

          let qty = 0;

          row.original.materials?.forEach((m) => {
            // console.log("mmmmmmm", m.quantity, m.length);
            if (!isPlate) qty += Number(m?.length) * Number(m?.quantity) || 0;
          });
          function formatNumber(num) {
            return Number.isInteger(num) ? num : num.toFixed(2);
          }

          // console.log("qty", qty);
          return isPlate
            ? // <CustomInputCell
              //   name="length"
              //   row={row}
              //   onChange={onChange}
              //   type="string"
              //   placeholder="Add Dimension"
              // />
              row.original.length
            : qty !== 0
              ? formatNumber(Number(qty))
              : "";
        },
      },

      {
        accessorKey: "unit",
        header: "Unit",
        enableEditing: false,
        size: 60,

        Cell: ({ row }) => {
          const isPlate = row.original?.description
            ?.toLowerCase()
            .includes("plate");
          const isPipe = row.original?.description
            ?.toLowerCase()
            .includes("pipe");
          const isHead = row.original?.costCode?.toLowerCase().includes("head");

          const unit = row.original?.unit;

          if (unit) {
            return unit;
          } else if (isPlate && !isHead) {
            return (
              <CustomInputCell
                name="unit"
                row={row}
                onChange={onChange}
                type="string"
              />
            );
          } else if (isPipe && !isHead) {
            return "mm";
          } else {
            return "Nos";
          }
        },
      },
      {
        accessorKey: "quantity",
        header: "Qty",
        enableEditing: false,
        ...rightBorder,
        grow: false,
        size: 10,
        Cell: ({ row }) => {
          // console.log("row", row.original);

          const isPlate = row.original?.description
            ?.toLowerCase()
            .includes("plate");

          let length = 0;

          row.original.materials?.forEach((m) => {
            // console.log("mmmmmmm", m.quantity, m.length);
            if (!isPlate)
              length += Number(m?.length) * Number(m?.quantity) || 0;
          });
          function formatNumber(num) {
            return Number.isInteger(num) ? num : num.toFixed(2);
          }

          let qty = 0;

          row.original.materials?.forEach((m) => {
            // console.log("mmmmmmm", m.quantity, m.length);
            if (isPlate || !length) qty += Number(m?.quantity) || 0;
          });

          // console.log("qty", qty);
          return (isPlate || !length) && qty !== 0
            ? formatNumber(Number(qty))
            : "1";
        },
      },
    ],
  },
  // ------------------------------------- Procured Data -------------------------------------

  {
    accessorKey: "Procurement Data",
    header: "Procurement Data",
    ...fullHeadBorder,
    columns: [
      {
        accessorKey: "reqQty",
        header: "Req. Qty",
        enableEditing: false,
        grow: false,
        size: 10,
        ...leftBorder,
        ...rightBorder,
        Cell: ({ row }) => {
          return (
            <CustomInputCell
              name="reqQty"
              row={row}
              onChange={onChange}
              placeholder="Req Quantity"
            />
          );
        },
      },
      {
        accessorKey: "procuredQty",
        header: "Procure Qty",
        enableEditing: false,
        grow: false,
        size: 10,
        Cell: ({ row }) => {
          return (
            <CustomInputCell
              name="procuredQty"
              row={row}
              onChange={onChange}
              placeholder="Add Quantity"
            />
          );
        },
      },
      {
        accessorKey: "procuredUnit",
        header: "Unit",
        enableEditing: false,
        grow: false,
        size: 10,
        ...rightBorder,
        Cell: ({ row }) => {
          const options = ["Ft", "Ft²", "Nos"];
          const value = row.original?.procuredUnit || "";

          return (
            <FormControl variant="standard" fullWidth>
              <Select
                name="procuredUnit"
                value={value}
                onChange={(e) => onChange(e, row.original)}
                displayEmpty
                size="small"
              >
                {options.map((opt) => (
                  <MenuItem key={opt} value={opt}>
                    {opt}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          );
        },
      },
      {
        accessorKey: "remarks",
        header: "Remarks",
        enableEditing: false,
        grow: false,
        size: 200,
        ...rightBorder,
        Cell: ({ row }) => {
          return (
            <CustomInputCell
              name="remarks"
              row={row}
              onChange={onChange}
              type="string"
            />
          );
        },
      },
    ],
  },
];

export const bulkDescriptionMrqMaterialsCols = (
  isEditMode,
  onChange,
  tasks,
) => [
  // {
  //   accessorKey: "wbs",
  //   header: "WBS Code/Task",
  //   enableEditing: false,
  //   grow: false,
  //   size: 100,
  //   Cell: ({ row }) => {
  //     const [value, setValue] = useState(row.original.wbs);
  //     const handleChange = async (event) => {
  //       const selectedTask = event.target.value;

  //       const code = selectedTask.match(/^\d+(\.\d+)?/)?.[0];

  //       const task = tasks.find((t) => t.taskCode === code);

  //       console.log("row in Mrq", row);
  //       const res = await secondAxios.patch(
  //         "/mrqMaterials/" + row.original.id,
  //         {
  //           taskId: task?.id,
  //           wbs: selectedTask,
  //         },
  //       );

  //       if (res?.data) {
  //         setValue(selectedTask);
  //         onChange(
  //           { target: { name: "taskId", value: task?.id } },
  //           row.original.id,
  //         );
  //         onChange(
  //           { target: { name: "wbs", value: selectedTask } },
  //           row.original.id,
  //         );
  //       }
  //     };

  //     return isEditMode ? (
  //       <FormControl variant="standard" fullWidth>
  //         <Select value={value} onChange={handleChange} label="wbs">
  //           {tasks.map((task) => {
  //             return (
  //               <MenuItem
  //                 key={task.id}
  //                 value={task.taskCode + " (" + task.task + ")"}
  //               >
  //                 {task.taskCode + " (" + task.task + ")"}
  //               </MenuItem>
  //             );
  //           })}
  //         </Select>
  //       </FormControl>
  //     ) : (
  //       value
  //     );
  //   },
  // },
  {
    accessorKey: "costCode",
    header: "Cost Code",
    enableEditing: false,
    grow: false,
    size: 60,
    Cell: ({ row }) => {
      return <Box>{row.original.materials?.[0]?.costCode}</Box>;
    },
  },
  {
    accessorKey: "description",
    header: "Description",
    enableEditing: false,

    size: 230,
  },

  {
    accessorKey: "procuredQty",
    header: "Procure Qty",
    enableEditing: false,
    grow: false,
    size: 10,
    Cell: ({ row }) => {
      return isEditMode ? (
        <TextField
          fullWidth
          name="procuredQty"
          type="number"
          value={row.original.procuredQty}
          error={!row.original.procuredQty}
          onChange={(e) => onChange(e, row.original.id)}
          sx={{ "& input": { px: 1, py: 0.5 } }}
        />
      ) : (
        row.original.procuredQty
      );
    },
  },
  {
    accessorKey: "procuredUnit",
    header: "Unit",
    enableEditing: false,

    size: 60,
    // Cell: ({ row }) => {
    //   const isPlate = row.original?.description
    //     ?.toLowerCase()
    //     .includes("plate");
    //   // const isPipe = row.original?.description?.toLowerCase().includes("pipe");
    //   // const isHead = row.original?.costCode?.toLowerCase().includes("head");
    //   if (isPlate) {
    //     return "Ft²";
    //   } else {
    //     return "Ft";
    //   }
    //   // if (row.original.unit) {
    //   //   return row.original.unit;
    //   // } else if (isPipe && !isHead) {
    //   //   return "mm";
    //   // } else {
    //   //   return "Nos";
    //   // }
    // },
  },

  {
    accessorKey: "remarks",
    header: "Remarks",
    enableEditing: false,
    grow: false,
    size: 250,
    Cell: ({ row }) => {
      return isEditMode ? (
        <TextField
          fullWidth
          name="remarks"
          value={row.original.remarks}
          onChange={(e) => onChange(e, row.original.id)}
          sx={{ "& input": { px: 1, py: 0.5 } }}
        />
      ) : (
        row.original.remarks
      );
    },
  },
];
